<select class="form-select" [(ngModel)]="currentSelection" (ngModelChange)="selectionChange.emit(currentSelection)">
  <option *ngFor="let i of inventoryFields" [ngValue]="i">{{translate.instant('lang.inventory.' + i.type)}}</option>
</select>
